import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

// ─────────────────────────────────────────────────────────────────────────────
// ProtectedRoute
//
// Wrap routes that require a logged-in user.
// Redirects to /login?redirect={currentPath} so the user returns here
// automatically after signing in.
// ─────────────────────────────────────────────────────────────────────────────

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location                       = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-terminal-bg">
        <span className="animate-pulse font-mono text-terminal-green">
          Authenticating…
        </span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
